//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Testimonial index
     */
    index: {
      type: Number,
      required: true
    },
    /**
     * Src video
     */
    src: {
      type: String,
      required: true
    },
    /**
     * User name
     */
    name: {
      type: String,
      default: ''
    },
    /**
     * Goal
     */
    goal: {
      type: String,
      default: null
    },
    /**
     * Overlay image src
     */
    overlayImage: {
      type: String,
      default: ''
    },
    /**
     * Video name to identify the video that it is open
     */
    videoName: {
      type: String,
      default: ''
    },
    /**
     * Media where container is open
     */
    media: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showVideo: false
    }
  },
  methods: {
    openVideo (ev) {
      ev.preventDefault()
      this.$root.$emit('bv::show::modal', `videoModal-${this.media}-${this.videoName}`)
    }
  }
}

